import { TCountryCode } from 'countries-list';
import polygonsJSON from '../data/polygons.json';
import polygonsJSON2 from '../data/polygons2.json';

// FIXME: THIS IS INEFFICIENT AND PURELY FOR THE DEMO!
// Converted countries.geojson (from https://datahub.io/core/geo-countries) to polygons.json using geojsonToObject.ts
export type geometry = [number, number][][][];
export const getCountryPolygons2: (country_code: TCountryCode, sk: (geometry: geometry) => void) => void = (country_code, sk) => {
  const polygons = { ...polygonsJSON, ...polygonsJSON2 } as unknown as Record<TCountryCode, { type: string, coordinates: geometry } | undefined>;
  const result = polygons[country_code];
  const coordinates = result?.coordinates;
  if (coordinates){
    sk(coordinates);
  } else {
    console.log('No coordinates for country ' + country_code);
  }
};
